module.exports = __webpack_public_path__ + "fonts/ProximaNovaA-Semibold.030fd8563464a08c7f3e1d83dc11cc50.woff2";